module.exports = __webpack_public_path__ + "img/com.codeway.rockidentifier.463a8977.png";